module.exports = __webpack_public_path__ + "img/Production-ApparelCertificate.b73daced.jpg";